export default {
    targetingParamLimit: 20,
    confidenceThreshold: 0,
};
